import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-modal-detail',
  templateUrl: './modal-detail.component.html',
  styleUrls: ['./modal-detail.component.scss'],
})
export class ModalDetailComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() title: string;
  @Input() text: any;
  @Output() fecharModal = new EventEmitter();

  constructor(private toast: ToastrService,
    private api: ApiService,
    private loading: NgxSpinnerService,
    private storage: StorageService) {
    }

  ngOnInit() {
  }


  fechar() {
    this.fecharModal.emit();
  }

  adicionar() {
    this.fecharModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-detail/modal-detail.component.ts